import React, { Component } from "react";
import ErrorMessage from "../components/error-message";
import "./view.css";

export default class View extends Component {
    static get title () {
        return "представление";
    }

    static get titleShort() {
        return null;
    }

    static get defaultProps() {
        return {};
    }

    static get propTypes() {
        return {
            gotoNextView: React.PropTypes.func.isRequired
        };
    }

    constructor (props) {
        super(props);
        this.state = {
            isErrorMessageVisible: false,
            errorMessageText: "",
        };
    }

    showErrorMessage(text) {
        this.setState({
            isErrorMessageVisible: true,
            errorMessageText: text,
        });
    }

    hideErrorMessage() {
        this.setState({
            isErrorMessageVisible: false,
            errorMessageText: "",
        });
    }

    renderErrorMessage() {
        return (<ErrorMessage text={this.state.errorMessageText} onRetryClick={() => this.handleRetryClick()} />);
    }

    handleRetryClick() {
        throw new ReferenceError("Not implemented");
    }
}


/** WEBPACK FOOTER **
 ** ./src/widgets/appointment-widget/views/view.js
 **/